import { render, staticRenderFns } from "./DealersView.vue?vue&type=template&id=24895a8e&scoped=true&"
import script from "./DealersView.vue?vue&type=script&lang=js&"
export * from "./DealersView.vue?vue&type=script&lang=js&"
import style0 from "./DealersView.vue?vue&type=style&index=0&id=24895a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24895a8e",
  null
  
)

export default component.exports